import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { MessageHandler } from 'src/app/utils/form-field-message-handler';
import { Mask } from 'src/app/utils/masks';
import { onChangeDate, openCalendarDatepicker } from 'src/app/utils/moment-config-datepicker';
import { RegisterIconsService } from 'src/app/services/register-icons.service';
import { FiltroControllerService } from 'src/app/services/filtro-controller.service';
import { ApiCorretoraService } from 'src/app/services/api-corretora.service';
import { IntegracaoConstants } from 'src/app/constants/integracao';
import { CommonModule } from '@angular/common';
import { ModulosDeFormulario } from 'src/app/utils/formsModules';

@Component({
    selector: 'filtro-corretoras',
    templateUrl: './corretoras-filtro.component.html',
    styleUrls: ['./corretoras-filtro.component.scss'],
    imports: [CommonModule, ModulosDeFormulario],
})
export class CorretorasFiltroComponent implements OnInit {

  errorMessage = MessageHandler.errorMessage;
  masks = Mask;
  statusAtual = this.filtroController.filtroCorretoras?.situation ? this.filtroController.filtroCorretoras?.situation : '';
  appOrigemModel = this.filtroController.filtroCorretoras?.aplicacaoOrigem ? this.filtroController.filtroCorretoras?.aplicacaoOrigem : '';
  statusCor = this.filtroController.filtroCorretoras?.status ? this.filtroController.filtroCorretoras?.status : "";
  diasUltSessao = this.filtroController.filtroCorretoras?.diasSemUso ? this.filtroController.filtroCorretoras?.diasSemUso : null; 

  // appOrigemModel: number
  appOrigem = IntegracaoConstants.appOrigem;

  // Diz que vai enviar um evento para 'eventFilter'
  @Output('eventFilter') eventFilter = new EventEmitter();
  @Output('clearFilter') limpaFiltro = new EventEmitter();

  constructor(
    private corretoraService: ApiCorretoraService,
    private icons: RegisterIconsService,
    public filtroController: FiltroControllerService
  ) {
    icons.registerIcons(['calendar'])	
   }

  ngOnInit() {

  }

  onChange = onChangeDate;
  openCalendar = openCalendarDatepicker;

  buildString() {
    let jsonEnvio = {
      status: this.statusCor,
      diasSemUso: this.diasUltSessao,
      situation: this.statusAtual,
      aplicacaoOrigem: this.appOrigemModel,
    }
    let filtros = { values: jsonEnvio }
    this.filtroController.addFiltrosExtras('corretoras', filtros);
    this.eventFilter.emit(filtros)
    return filtros;
  }

  clearFilter() {
    this.diasUltSessao = null;
    this.statusAtual = "";
    this.statusCor = "";	
    this.appOrigemModel = "";	
    this.limpaFiltro.emit("");
    this.filtroController.limparFiltro('corretoras')
    this.buildString();
  }

}
